import { useAppActions } from "../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppSelector } from "../internal/shared/lib/store/hooks/useAppSelector.js";
import { selectSlice } from "../internal/shared/store/config/model/selectors/selectSlice.js";
import "../internal/shared/store/config/model/slice.js";
function useConfig() {
  const config = useAppSelector(selectSlice);
  const {
    config: { setApiRoot, setClientId, setCreditParamsFormatter }
  } = useAppActions();
  return {
    data: config,
    actions: {
      setApiRoot,
      setClientId,
      setCreditParamsFormatter
    }
  };
}
export {
  useConfig
};
